/*
  Un-crop the variant swatch photographs.

  THE BUG THIS FIXES, AND WHY CSS COULDN'T
  ----------------------------------------
  Variant Swatch King asks Shopify's CDN for a HARD-CROPPED derivative:

      .../otel_elcampo.png?v=…&width=250&height=300&crop=top

  `crop=top` means "take a 250x300 window anchored at the top" — of a source
  that is 569x732. The bottom of the product is cut off in the PIXELS, before
  the image ever reaches the page. `background-size: contain` in
  ecofuego-pdp.css was already doing its job perfectly: it was faithfully
  fitting an image that had already had its feet cut off. Two rounds of CSS
  went into that band before anyone read the URL.

  So the fix has to happen at the request. This strips `height` and `crop` and
  raises `width`, which leaves the CDN returning the whole photograph at its
  natural ratio, and `contain` then does what it always claimed to.

  WHY A MUTATION OBSERVER
  -----------------------
  The app re-renders its swatch list on variant change and on its own async
  init, and each render writes fresh background URLs with the crop back in. A
  one-shot pass on DOMContentLoaded fixes the tiles you first see and loses
  them again the moment somebody clicks a colour. The observer is not
  belt-and-braces here, it is the only version that survives interaction.

  IF THE APP EVER EXPOSES A "DON'T CROP" SETTING, USE THAT AND DELETE THIS.
  Rewriting another vendor's URLs is a workaround, and it is one line away from
  breaking if they change their markup — the guard is that it only ever touches
  elements matching `.star-set-image`, and only ever removes two query
  parameters. If the selector stops matching, the tiles go back to being
  cropped; nothing else breaks.
*/
(function () {
  'use strict';

  var SELECTOR = 'variant-swatch-king .star-set-image';
  // Retina: the tile is ~212 CSS px wide, so 600 covers a 2x display with room
  // to spare without pulling the full 4000px original.
  var WIDTH = '600';

  function uncropOne(el) {
    var bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage;
    if (!bg || bg.indexOf('http') === -1) return;

    var raw = bg.slice(bg.indexOf('http'));
    raw = raw.replace(/["')\s]+$/, '');

    var url;
    try {
      url = new URL(raw, window.location.origin);
    } catch (e) {
      return;
    }

    // Only Shopify's own image CDN takes these parameters. Anything else is
    // left exactly as the app wrote it.
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url.href)) return;
    if (!url.searchParams.has('crop') && !url.searchParams.has('height')) return;

    url.searchParams.delete('crop');
    url.searchParams.delete('height');
    url.searchParams.set('width', WIDTH);

    var next = 'url("' + url.href + '")';
    if (next !== el.style.backgroundImage) {
      el.style.setProperty('background-image', next, 'important');
    }
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < found.length; i++) uncropOne(found[i]);
    // A mutation can land ON a matching element rather than inside one.
    if (scope.matches && scope.matches(SELECTOR)) uncropOne(scope);
  }

  function start() {
    sweep(document);

    var host = document.querySelector('variant-swatch-king');
    if (!host || typeof MutationObserver === 'undefined') return;

    var pending = false;
    var observer = new MutationObserver(function (records) {
      // Writing a background-image is itself a mutation, so react on a
      // microtask rather than synchronously — otherwise the observer sees its
      // own writes and spins.
      if (pending) return;
      pending = true;
      Promise.resolve().then(function () {
        pending = false;
        for (var i = 0; i < records.length; i++) {
          var t = records[i].target;
          sweep(t.nodeType === 1 ? t : document);
        }
      });
    });

    observer.observe(host, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // The app initialises asynchronously and can paint its tiles after our first
  // pass. Two cheap late sweeps cost nothing and cover a slow init.
  setTimeout(function () { sweep(document); }, 800);
  setTimeout(function () { sweep(document); }, 2500);
})();
